import React, { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';
import { Grid, Cell } from 'formlabs-web-components/Grid';
import { Link } from 'formlabs-web-components/Link';
import CountryContext from '../../context/country';
import StoreButton from '../storefront/MenuButton';

import './HeaderMenu.module.css';

class StickyNav extends PureComponent {
  static contextType = CountryContext;

  render() {
    const { secondaryMenu, stuck, countrySite, t } = this.props;
    const { storePage } = this.context;
    return (
      <div styleName={`sticky-nav ${stuck ? 'stuck' : ''}`}>
        {!secondaryMenu && (
          <Grid
            direction="x"
            primaryAlignment="align-justify"
            hasContainer={true}
          >
            <Cell mediumSize={12}>
              <div styleName="sticky-phone">
                <Link to="#">
                  <i className="fl-phone" /> {t('Sales')}:{' '}
                  {countrySite.phoneNumberSales}
                </Link>
              </div>
            </Cell>
            <Cell mediumSize={12}>
              <div className="text-right" styleName="sticky-nav-right">
                {/* FIXME replace hardcoded form 2 link */}
                <Link to="/3d-printers/form-2">{t('See the Form 2')}</Link>
                {/* FIXME replace hardcoded sample parts link */}
                <Link to="/request-sample-part">
                  {t('Request Sample Part')}
                </Link>
                {storePage && <StoreButton />}
              </div>
            </Cell>
          </Grid>
        )}
      </div>
    );
  }
}

export default withTranslation()(StickyNav);
